// src/components/tutorials/JS_Number_Reference.jsx
import React from "react";
import "../../../AllComponentCSS.css";

export default function JS_Number_Reference() {
  const numberReference = [
    {
      name: "constructor",
      description:
        "Returns the function that created JavaScript's Number prototype",
    },
    {
      name: "EPSILON",
      description:
        "Returns the difference between 1 and the smallest number greater than 1",
    },
    {
      name: "isFinite()",
      description: "Checks whether a value is a finite number",
    },
    {
      name: "isInteger()",
      description: "Checks whether a value is an integer",
    },
    { name: "isNaN()", description: "Checks whether a value is Number.NaN" },
    {
      name: "isSafeInteger()",
      description: "Checks whether a value is a safe integer",
    },
    {
      name: "MAX_SAFE_INTEGER",
      description: "Returns the maximum safe integer in JavaScript",
    },
    {
      name: "MIN_SAFE_INTEGER",
      description: "Returns the minimum safe integer in JavaScript",
    },
    {
      name: "MAX_VALUE",
      description: "Returns the largest number possible in JavaScript",
    },
    {
      name: "MIN_VALUE",
      description: "Returns the smallest number possible in JavaScript",
    },
    { name: "NaN", description: 'Represents a "Not-a-Number" value' },
    {
      name: "NEGATIVE_INFINITY",
      description: "Represents negative infinity (returned on overflow)",
    },
    {
      name: "POSITIVE_INFINITY",
      description: "Represents infinity (returned on overflow)",
    },
    {
      name: "parseFloat()",
      description: "Parses a string and returns a number",
    },
    {
      name: "parseInt()",
      description: "Parses a string and returns a whole number",
    },
    {
      name: "prototype",
      description: "Allows you to add properties and methods to an object",
    },
    {
      name: "toExponential(x)",
      description: "Converts a number into an exponential notation",
    },
    {
      name: "toFixed(x)",
      description:
        "Formats a number with x numbers of digits after the decimal point",
    },
    {
      name: "toLocaleString()",
      description:
        "Converts a number into a string, based on the locale settings",
    },
    { name: "toPrecision(x)", description: "Formats a number to x length" },
    { name: "toString()", description: "Converts a number to a string" },
    {
      name: "valueOf()",
      description: "Returns the primitive value of a number",
    },
  ];

  return (
    <div className="tutorial-container" style={{ padding: "2rem" }}>
      <h1 className="tutorial-title" style={{ textAlign: "center" }}>
        🔢 JavaScript Number Reference
      </h1>
      <p style={{ textAlign: "center", color: "#555", marginBottom: "1rem" }}>
        A complete list of Number properties and methods (Updated 2025)
      </p>

      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          overflow: "hidden",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                background: "linear-gradient(90deg, #6366f1, #60a5fa)",
                color: "white",
                textAlign: "left",
              }}
            >
              <th style={{ padding: "14px 20px", fontWeight: "600" }}>Name</th>
              <th style={{ padding: "14px 20px", fontWeight: "600" }}>
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            {numberReference.map((item, index) => (
              <tr
                key={item.name}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f8fafc" : "#eef2ff",
                  transition: "background 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#dbeafe")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    index % 2 === 0 ? "#f8fafc" : "#eef2ff")
                }
              >
                <td
                  style={{
                    padding: "14px 20px",
                    borderBottom: "1px solid #e2e8f0",
                    fontWeight: "500",
                  }}
                >
                  {item.name}
                </td>
                <td
                  style={{
                    padding: "14px 20px",
                    borderBottom: "1px solid #e2e8f0",
                  }}
                >
                  {item.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          background: "linear-gradient(135deg, #c7d2fe, #a5b4fc)",
          padding: "1rem 2rem",
          borderRadius: "12px",
          marginTop: "2rem",
          maxWidth: "900px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h2 style={{ color: "#1e3a8a" }}>🚀 Next Steps</h2>
        <ul style={{ lineHeight: "1.8" }}>
          <li>
            Use Number properties and methods to handle numeric operations
            safely.
          </li>
          <li>
            Understand limits, precision, and safe integers to avoid unexpected
            errors.
          </li>
          <li>
            Combine with <code>parseInt()</code>, <code>parseFloat()</code>, and{" "}
            <code>toFixed()</code> for formatting.
          </li>
          <li>
            Try <code>toLocaleString()</code> for localizing number output.
          </li>
          <li>Bookmark this table as your quick Number reference guide.</li>
        </ul>
      </div>
    </div>
  );
}
